export function flattenValidationExceptionMessages(data) {
  if (!data || data.__typename !== 'ValidationException') {
    return [];
  }

  return data.messages.concat(...data.details.map((d) => d.messages));
}
